import { useLocation } from "react-router-dom";
import { CardListPage } from "components/Category/Category";
import { formatSupplierFeedbackRow } from "./SupplierFeedbackList.formatters";
import { getCrudItems } from "./SupplierFeedbackList.crud";
import {
  rowCellOptions,
  SUPPLIER_FEEDBACK_LIST_COLUMNS,
  SUPPLIER_FEEDBACK_LIST_ENDPOINTS,
} from "./SupplierFeedbackList.config";
import { SupplierFeedbackRow, SupplierFeedbackListProps } from "./SupplierFeedbackList.types";

/**
 * Custom hook to generate all Category component props for supplier feedback types
 * @param props - Supplier feedback list component props
 * @param location - React Router location object
 * @returns Object containing all props needed for the Category component
 */
export function useSupplierFeedbackCategoryProps(
  props: SupplierFeedbackListProps,
  location: ReturnType<typeof useLocation>
) {
  const crudItems = getCrudItems();

  return {
    location,
    noun: "supplier feedback",
    idColumn: SUPPLIER_FEEDBACK_LIST_COLUMNS.Id,
    listEndpointUrl: SUPPLIER_FEEDBACK_LIST_ENDPOINTS.list,
    defaultBActiveFilterColumnKey: SUPPLIER_FEEDBACK_LIST_COLUMNS.Active,
    rowFormatter: formatSupplierFeedbackRow,
    hiddenColumns: [SUPPLIER_FEEDBACK_LIST_COLUMNS.Id] as (keyof SupplierFeedbackRow)[],
    crudComponents: crudItems,
    hideHeaderTitle: true,
    defaultCardOrListView: CardListPage.List,
    largeRightPanel: false,
    hideCardPage: true,
    rowCellOptions,
  };
}
